import { styled } from "styled-components";

import { useChatClass } from "../../theme";

type Props = {
  $size: number;
};

const Container = styled.div<Props>(({ $size }) => {
  return {
    height: $size,
    width: $size,
  };
});

const Spinner = styled.div<Props>(({ theme, $size }) => {
  return {
    height: $size,
    width: $size,
    borderWidth: "2px",
    borderStyle: "solid",
    borderRadius: theme.radii.round,
    borderColor: "#f0f0f0",
    borderTopColor: "#000",
    animation: "spin 1000ms linear",
    animationIterationCount: "infinite",
  };
});

interface LoaderProps {
  /** Size of the loader in pixels. Height and width are the same. */
  size?: number;
}

/**  An infinite loading spinner. Default size is 32 x 32 px */
export const Loader: React.FC<LoaderProps> = ({ size = 32 }: LoaderProps) => {
  const chatClass = useChatClass();
  return (
    <Container $size={size} className={chatClass("loader")}>
      <Spinner $size={size} />
    </Container>
  );
};
